/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGitbookIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-gitbook" */ './utils').then((m) => m.GitbookIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/gitbook/icon' },
);

const LazyGitbookSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-gitbook-search-result" */ './utils').then(
			(m) => m.GitbookSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GitbookIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGitbookIconComponent />
	</Suspense>
);

export const GitbookSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGitbookSearchResultIconComponent />
	</Suspense>
);
